const actions = {
  filter: 'filter',
  date_picker: 'date_picker',
  toggle: 'toggle',
  docs: 'docs',
  support: 'support',
  payment_stage: 'payment_stage',
  granularity: 'granularity',
  break_down: 'break_down',
  search: 'search',
  payment_details: {
    transaction_activity: 'payment_details/transaction_activity',
    payment_information: 'payment_details/payment_information'
  },
  data_type_view: 'data_type_view'
}

export default actions
